/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many bins are used?`)
};

const es_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos intervalos se usan?`)
};

const de_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Klassen werden verwendet?`)
};

const nl_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel klassen worden gebruikt?`)
};

const fr_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de classes sont utilisées ?`)
};

const it_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quante classi vengono usate?`)
};

const pt_br2_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos bins são usados?`)
};

const pt_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantas classes são usadas?`)
};

const ja_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビンの数はいくつ使われますか？`)
};

const zh_hist_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用多少个箱？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_faq_q2", locale)
	if (locale === "en") return en_hist_faq_q2(inputs)
	if (locale === "es") return es_hist_faq_q2(inputs)
	if (locale === "de") return de_hist_faq_q2(inputs)
	if (locale === "nl") return nl_hist_faq_q2(inputs)
	if (locale === "fr") return fr_hist_faq_q2(inputs)
	if (locale === "it") return it_hist_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_hist_faq_q2(inputs)
	if (locale === "pt") return pt_hist_faq_q2(inputs)
	if (locale === "ja") return ja_hist_faq_q2(inputs)
	return zh_hist_faq_q2(inputs)
};